$(document).ready(() => {
    //video defer
    if ($('.video-container').length > 0) {
        function init() {
            setTimeout(function(){
                var vidDefer = document.getElementsByTagName('iframe');

                for (var i=0; i<vidDefer.length; i++) {

                    if(vidDefer[i].getAttribute('data-src')) {

                        let youtubeURL = vidDefer[i].getAttribute('data-src');

                        var id = youtubeURL.substr(youtubeURL.lastIndexOf("v=") + 2, 11);

                        let embedSrc = 'https://www.youtube.com/embed/'+id+'?enablejsapi=1';

                        vidDefer[i].setAttribute('src', embedSrc);

                    }
                }
            },0)
        }

        $('.video-container .video-play-btn').on('click', function(e) {
          e.preventDefault();
          $(this).closest(".video-container").find("iframe")[0].src += "&autoplay=1";
          $(this).hide();
        })

        init();
    };

    //video defer END

    $(window).scroll(function(){
      if($(window).scrollTop() > 50) {
        $("#page-header").addClass("active")
      } else {
        $("#page-header").removeClass("active")
      }
    });

    //mobile nav
    $("#mobile-nav-btn").click(() => {
      $("#main-nav").addClass("active")
    });

    $("#mobile-nav-close, .main-nav .scroll-link").click(() => {
      $("#main-nav").removeClass("active")
    });

    //hero slider
    $(".slider").slick({
      arrows: true,
      dots: true,
      mobileFirst: true,
      infinite: false,
      slidesToShow: 1,
      prevArrow: $("#slider-prev"),
      nextArrow: $("#slider-next"),
      appendDots: $("#slider-dots"),
      responsive: [{

          breakpoint: 500,
          settings: {
            slidesToShow: 1.3,
          }

        }, {

          breakpoint: 1024,
          settings: {
            slidesToShow: 1.66,
          }

        }]
    });

    //champions table
    new DataTable('#players-table', {
      order: [],
      searching: false,
      paging: false,
      info: false,
      //columns: [{ type: 'num' }, null, null, { type: 'num' }, { type: 'num' }, null]
    });

    //match height join-box
    $('.join-box__content').matchHeight();
})